import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import RightIcon from '@material-ui/icons/ChevronRight';
import LeftIcon from '@material-ui/icons/ChevronLeft';

const styles = theme => ({
	paginator:{
		display: "inline"
	}
});

/* Parameters: page: int, rightDisabled: bool, updatePage: func */
class Paginator extends React.Component {
  constructor(props) {
  	super(props);
  	this.handleInc = this.handleInc.bind(this);
  	this.handleDec = this.handleDec.bind(this);
  }

  handleInc() {
  	this.props.updatePage(1);	
  }

  handleDec() {
  	if (this.props.page>0)
  		this.props.updatePage(-1);
  }

  render() {
  	const { classes } = this.props;
  	return (
  		<div>
  			<IconButton 
	  			className={classes.paginator}
	  			onClick={this.handleDec}
	  			disabled={this.props.page<1}
  			>
  				<LeftIcon />
  			</IconButton>
  			<Typography className={classes.paginator}>
  				{"Page "+(this.props.page + 1)}
  			</Typography>
  			<IconButton 
	  			className={classes.paginator}
	  			onClick={this.handleInc}
	  			disabled={this.props.rightDisabled}
  			>
  				<RightIcon />
  			</IconButton>
  		</div>
  	)
  }
}

Paginator.propTypes = {
  	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Paginator);


